import { useMemo } from 'react';
import { useUpdateEffect } from 'react-use';

import { Bean, NumberPatternType, ValidationRules } from '@dreryk/react-common';

import { getPreciseDosageFrequencyMaxValue, getPreciseDosageFrequencyMinValue } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { DraftPrescriptionsFormController } from '../../draftPrescriptions/DraftPrescriptionsForm.types';
import { DraftStandardPrescriptionFieldName } from '../../draftPrescriptions/standardPrescription/DraftStandardPrescriptionField.types';

import { StyledFrequencyNumberInput } from './FrequencyNumberInput.styled';

type FrequencyNumberInputProps = Pick<DraftPrescriptionsFormController, 'register' | 'trigger'> & {
   readonly name: DraftStandardPrescriptionFieldName;
   readonly defaultValue: number | null;
   readonly required: boolean;
   readonly notAllowed: boolean;
};

export const FrequencyNumberInput = (props: FrequencyNumberInputProps): JSX.Element => {
   useUpdateEffect(() => {
      props.trigger(props.name);
   }, [props.notAllowed, props.trigger, props.name]);

   const validationRules = useMemo<ValidationRules<Bean>>(
      () => ({
         required: props.required,
         validate: () => !props.notAllowed,
      }),
      [props.required, props.notAllowed]
   );

   return (
      <StyledFrequencyNumberInput
         testId={'numericalDosageFrequency'}
         controller={props.register(props.name, validationRules)}
         placeholder={prescriptionTranslationKeys.numericalDosage.howOften}
         defaultValue={props.defaultValue}
         min={getPreciseDosageFrequencyMinValue()}
         max={getPreciseDosageFrequencyMaxValue()}
         pattern={NumberPatternType.POSITIVE_INTEGER}
         autoComplete={false}
         compact
      />
   );
};
